const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Official brand wordmark logos (dark ink on transparent — built for light surfaces).
const WORDMARKS = {
  hexcore: `${BACKEND_URL}/api/static/brand/hexcore_logo.png`,
  profoam: `${BACKEND_URL}/api/static/brand/profoam_logo.png`,
};

/**
 * Renders the product's brand wordmark logo wherever the product name is used as a heading.
 * Falls back to plain text for any product without a logo.
 * `imgClassName` controls the rendered height (e.g. "h-9", "h-12 md:h-14").
 */
export const ProductWordmark = ({
  slug,
  name,
  imgClassName = 'h-9',
  className = '',
  fallbackClassName = '',
}) => {
  const src = WORDMARKS[slug];
  if (!src) {
    return <span className={fallbackClassName || className}>{name}</span>;
  }
  return (
    <img
      src={src}
      alt={name}
      className={`w-auto object-contain ${imgClassName} ${className}`}
      draggable={false}
      data-testid={`product-wordmark-${slug}`}
    />
  );
};
